import { Box, Text } from '@factorialco/deprecated-design-system'
import { Moment } from 'moment'

import { i18nDateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { calculateDateDifference } from 'modules/contracts/lib/contractDates'

interface Props {
  isActive: boolean
  endDate?: Moment | null
  effectiveDate?: Moment | null
}

const ActivityStart = ({ isActive, effectiveDate, endDate }: Props) => {
  const firsInactivityDate = endDate ? endDate.clone().add(1, 'day') : null
  const startDate = isActive ? effectiveDate : firsInactivityDate
  const { years, months, days } = startDate
    ? calculateDateDifference(startDate)
    : { years: 0, months: 0, days: 0 }
  const daysWithToday = days > 0 ? days + 1 : days
  const formattedStartDate = startDate ? i18nDateToString(startDate, 'ui_dmy_long') : null

  const tenureYears =
    years > 0
      ? i18n.tp('contract_versions.contract_information.start_date_years', { count: years })
      : ''
  const tenureMonths =
    months > 0
      ? i18n.tp('contract_versions.contract_information.start_date_months', { count: months })
      : ''
  const tenureDays =
    daysWithToday > 0
      ? i18n.tp('contract_versions.contract_information.start_date_days', { count: daysWithToday })
      : ''
  const tenure = `${tenureYears} ${tenureMonths} ${tenureDays}`.trim()
  const description = isActive
    ? i18n.t('contract_versions.fix_discontinuous.activity_start.new_title')
    : i18n.t('contract_versions.fix_discontinuous.inactivity_start.new_title')

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 3 }} gap="s8">
      <Box alignItems="center" flexDirection="row" height="s24">
        <Text size="200" weight="normal" color="grey800">
          {description}
        </Text>
      </Box>
      {startDate ? (
        <Text size="300" weight="medium" color="grey1000">
          {formattedStartDate}
        </Text>
      ) : (
        <Text size="300" weight="medium" color="grey600">
          {i18n.t('contract_versions.fix_discontinuous.not_informed')}
        </Text>
      )}
      <Text size="200" weight="normal" color="grey800">
        {tenure}
      </Text>
    </Box>
  )
}

export default ActivityStart
